// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","826":"component---src-pages-delete-account-js"}[chunkId] || chunkId) + "-" + {"293":"54d5e8dac74e18c0f02c","454":"794562760ecce700629a","510":"0fa1f05366731b64dcda","826":"fdde68259166da368106"}[chunkId] + ".js";
};